import { Tag } from "antd";

import { MarkedAs } from "types/enum";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

interface ICostItemMarkedAsCellProps {
    markedAs?: MarkedAs;
}

export const CostItemMarkedAsDisplay: React.FC<ICostItemMarkedAsCellProps> = (props) => {
    const markedAs = props.markedAs;
    if (!markedAs || markedAs === MarkedAs.None) {
        return null;
    }
    if (markedAs === MarkedAs.LegacyBidAllowance) {
        return (
            <>
                <Tag className="margin-right-xss">{MarkedAs[MarkedAs.Bid]}</Tag>
                <Tag>{MarkedAs[MarkedAs.Allowance]}</Tag>
            </>
        );
    }
    return <StatusTagDisplay statusText={MarkedAs[markedAs]} statusType="" />;
};

const CostItemMarkedAsCell: React.FC<IGridCellRenderProps<ICostItemMarkedAsCellProps>> = (
    props,
) => <CostItemMarkedAsDisplay markedAs={props.cellValue?.markedAs} />;

export const columnCostItemMarkedAs: IClientGridColumn<MarkedAs, ICostItemMarkedAsCellProps> = {
    columnType: GridColumnType.costItemMarkedAs,
    Cell: CostItemMarkedAsCell,
    mapper: (apiValue: MarkedAs): ICostItemMarkedAsCellProps => {
        return {
            markedAs: apiValue,
        };
    },
};
